module.exports = __webpack_public_path__ + "img/pallawi.25305dfe.jpg";